import {
  ApdmSendingPolicy,
  kApdmDefaultSendingPolicy,
} from '@euler/model/apdm/out-reaching';
import { apdmPlanSendingPolicyText } from './campaignLabels';

/** The sending policy a plan's campaign card shows, offers and launches. */
export interface ApdmPlanCardSendingPolicy {
  /** The policy the picker marks as selected. */
  selected: ApdmSendingPolicy;
  /** The one a plan with none launches with, marked 默认. */
  defaultPolicy: ApdmSendingPolicy;
  /** The card's 发送方式 row. */
  text: string;
  /** What the launch sends: only a pick that changes the plan's policy. */
  override: ApdmSendingPolicy | undefined;
  /**
   * Whether the card offers the picker. A card that does not name the
   * store's default came from a server that takes no pick, and could not
   * mark the default nor tell a pick from the plan's policy.
   */
  pickable: boolean;
}

/**
 * `plan` is the plan's own policy, `cardDefault` the store's default the
 * card was counted with (absent on an older card: the system's stands in),
 * `picked` the user's choice on the card, if any.
 */
export function apdmPlanCardSendingPolicy(
  plan: ApdmSendingPolicy | null | undefined,
  cardDefault: ApdmSendingPolicy | undefined,
  picked: ApdmSendingPolicy | null,
): ApdmPlanCardSendingPolicy {
  const defaultPolicy = cardDefault ?? kApdmDefaultSendingPolicy;
  const planned = plan ?? defaultPolicy;
  const selected = picked ?? planned;
  return {
    selected,
    defaultPolicy,
    // An older card cannot name the store's default it will launch with.
    text: apdmPlanSendingPolicyText(plan || cardDefault ? selected : null),
    override: selected !== planned ? selected : undefined,
    pickable: cardDefault !== undefined,
  };
}
